import { EMPTY_FUNCTION } from '../../../../constants/common'
import { AIVoiceInput, AIVoiceInputState } from '../../../AITextGeneration'
import { Container } from '../../Container'

const STATES = [
  AIVoiceInputState.Default,
  AIVoiceInputState.Connecting,
  AIVoiceInputState.Applying,
  AIVoiceInputState.Ready,
  AIVoiceInputState.Recording,
]

function AIVoiceInputLibrary() {
  return (
    <>
      {STATES.map(state => (
        <Container key={state} label={`AI Voice Input — ${state}`}>
          <AIVoiceInput state={state} onClick={EMPTY_FUNCTION} />
        </Container>
      ))}
      <Container label='AI Voice Input — default, disabled'>
        <AIVoiceInput
          disabled
          state={AIVoiceInputState.Default}
          onClick={EMPTY_FUNCTION}
        />
      </Container>
      <Container label='AI Voice Input — ready, disabled'>
        <AIVoiceInput
          disabled
          state={AIVoiceInputState.Ready}
          onClick={EMPTY_FUNCTION}
        />
      </Container>
    </>
  )
}

export default AIVoiceInputLibrary
